import React from "react";
import { useHistory } from "react-router-dom";
import { UrlInternal } from "common/constants/endpoints";
import * as S from "./style";

function ArtReadMore() {
  const history = useHistory();

  return (
    <S.ArtReadMore>
      <div className="guid">
        <div className="title">이용자 가이드</div>
        <div className="content">청약에 처음 참여하시는 분들을 위해</div>
        <button
          onClick={() =>
            history.push(UrlInternal.GROUP_SALE_GUIDE_CUSTOMER_SERVICE_STEP)
          }
        >
          알아보러 가기
        </button>
      </div>
    </S.ArtReadMore>
  );
}

export default ArtReadMore;
